var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFolders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 15C15.0871 15 15.8333 14.2538 15.8333 13.3333V5.83333C15.8333 4.91286 15.0871 4.16667 14.1666 4.16667H10.3416C10.123 4.16575 9.91353 4.07895 9.75831 3.925L8.57498 2.74167C8.41976 2.58771 8.21026 2.50092 7.99165 2.5H2.49998C1.5795 2.5 0.833313 3.24619 0.833313 4.16667V13.3333C0.833313 14.2538 1.5795 15 2.49998 15H14.1666ZM17.5 7.5V15C17.5 15.9205 16.7538 16.6667 15.8333 16.6667H4.16665C4.16665 17.5871 4.91284 18.3333 5.83331 18.3333H15.8333C17.6743 18.3333 19.1666 16.841 19.1666 15V9.16667C19.1666 8.24619 18.4205 7.5 17.5 7.5Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolders);
export default __webpack_public_path__ + "static/media/icon-folders.885873e0.svg";
export { ForwardRef as ReactComponent };